var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('zoon-header')],1),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('bottom-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.screenWidth<960),expression:"screenWidth<960"}],staticClass:"bottom",attrs:{"selected":_vm.selected,"tabBars":_vm.tabBars}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }